export const RUBRICS_ROUTING = [
  {
    path: '/:rubric',
    name: 'rubric',
    component: () =>
      import(/* webpackChunkName: "rubric-page" */ './pages/rubric/rubric.page'),
    alias: []
  }
];
